import React from 'react'
import BrokerApplicationDashboard from 'components/BrokerDashboard'

const BrokerDashboardContainer = () => {
    return <BrokerApplicationDashboard />
}

export default BrokerDashboardContainer
